export default __webpack_public_path__ + "static/media/man paint 1.143ee6d6.svg";